import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   addCustomerMasterApiCall,
   fetchAllContractorsApiCall,
   listCustomerMasterApiCall,
   updateCustomerMasterApiCall,
} from "../../Api/api";
import client from "../../Api/client";

// initial state
const initialState = {
   dataList: [],
   total: 0,
   pagination: null,
   singleCustomerMaster: null,

   contractors: [],

   isLoading: false,
   isError: false,
   isSuccess: false,
};

// add fleet
export const fetchAllContractorsAsync = createAsyncThunk(
   "driverMaster/fetch-contractors-driver",
   async (_, thunkAPI) => {
      try {
         const response = await fetchAllContractorsApiCall();

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// add fleet
export const addCustomerMasterAsync = createAsyncThunk(
   "customerMaster/add-customer-master",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await addCustomerMasterApiCall(data);

         if (response.data?.statusCode === 200 || response.data?.statusCode === 201) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// update fleet
export const updateCustomerMasterAsync = createAsyncThunk(
   "driverMaster/update-customer-master",
   async ({ data, err, done,id }, thunkAPI) => {
      try {
         const response = await updateCustomerMasterApiCall(id,data);

         if (response.data?.statusCode === 200 || response.data?.statusCode === 201) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res || response.data?.data);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// list customer
export const listCustomerMasterAsync = createAsyncThunk(
   "customerMaster/list-customer-master",
   async ({ params, err, done } = {}, thunkAPI) => {
      try {
         const response = await listCustomerMasterApiCall(params);

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// fetch single customer master
export const fetchSingleCustomerMasterAsync = createAsyncThunk(
   "driverMaster/fetch-single-customer master",
   async ({ id, err, done }, thunkAPI) => {
      try {
         const response = await client.get(
            `customer/${id}`,
            {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            },
         );

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// fetch single fleet child data
export const updateSingleCustomerChildAsync = createAsyncThunk(
   "fleetmaster/update-single-customer-child",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await client.post(`customer/update/child`, data, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// fetch single fleet child data
export const addSingleCustomerChildAsync = createAsyncThunk(
   "fleetmaster/add-single-customer-child",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const response = await client.post(`customer/add/child`, data, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

export const removeContactAsync = createAsyncThunk(
   "fleetmaster/remove-single-customer-child",
   async ({ id, err, done }, thunkAPI) => {
      try {
         const response = await client.get(`customer/delete/${id}?`, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

export const removeLocationAsync = createAsyncThunk(
   "fleetmaster/remove-single-location-child",
   async ({ id, err, done }, thunkAPI) => {
      try {
         const response = await client.get(`location/delete/${id}?`, {
            headers: {
               Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
            },
         });

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         const errorMessage =
            error?.response?.data?.message || "Failed to delete Location";

         err && err(errorMessage);
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data || errorMessage;
      }
   },
);

export const fetchChildTableDataAsync = createAsyncThunk(
   "fetch-child-table",
   async ({ id, tableName, err, done }, thunkAPI) => {
      try {
         const response = await client.get(
            `customer/fetch/child/${id}?&table_name=${tableName}&model_id=3&action_id=3`,
            {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            },
         );

         if (response.data?.statusCode === 200) {
            done && done(response?.data);
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   },
);

// fleet master slice
const customerMasterSlice = createSlice({
   name: "customerMaster",

   initialState: initialState,

   reducers: {
      clearDriverMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //
      builder.addCase(fetchAllContractorsAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllContractorsAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.contractors = action.payload;
      });
      builder.addCase(fetchAllContractorsAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(listCustomerMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listCustomerMasterAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         const rawList = Array.isArray(action.payload?.res)
            ? action.payload.res
            : Array.isArray(action.payload?.res?.data)
              ? action.payload.res.data
              : Array.isArray(action.payload?.data)
                ? action.payload.data
                : Array.isArray(action.payload)
                  ? action.payload
                  : [];
         state.dataList = rawList;
         state.pagination = action.payload?.pagination || null;
         state.total =
            action.payload?.pagination?.total ??
            (Array.isArray(action.payload?.res)
               ? action.payload.res.length
               : rawList.length);
      });
      builder.addCase(listCustomerMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(fetchSingleCustomerMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleCustomerMasterAsync.fulfilled, (state, action) => {
         state.isLoading = false;
         state.singleCustomerMaster = action.payload;
      });
      builder.addCase(fetchSingleCustomerMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });
   },
});

export const { clearDriverMasterState } = customerMasterSlice.actions;

const customerMasterReducer = customerMasterSlice.reducer;
export default customerMasterReducer;
